import React from 'react';
import { useTranslation } from 'react-i18next';

/** Logo + certifia.ai + Adaptive Learning (navbar). */
export default function AppNavBrand() {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          backgroundColor: '#3498db',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(52, 152, 219, 0.45)',
          flexShrink: 0,
        }}
        aria-hidden
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div style={{ lineHeight: 1.2, textAlign: 'left' }}>
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0.35,
            color: '#aed6f1',
            textTransform: 'lowercase',
          }}
        >
          {t('brand.nav_site')}
        </div>
        <div style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>{t('brand.nav_product')}</div>
      </div>
    </div>
  );
}
